(($) => {
  $.defaults.beforeShow = (instance, current) => {
    const encodedVpopContent = current.opts.encodedContent;
    if (typeof encodedVpopContent === "string") {
      let content = "<p>No content available</p>";
      if (encodedVpopContent.length > 0) {
        try {
          const decodedVpopContent = Buffer.from(encodedVpopContent, "base64");
          content = `<div>${decodedVpopContent}</div>`;
        } catch (err) {
          console.error(
            `Video pop-up content decoding failed with error: ${err}`
          );
        }
      }
      instance.setContent(current, content);
    }
  };
})(FancyappsUi);
